import React, { useCallback, useEffect } from 'react'

export const useDebouncedState = <T>(initialValue: T, delay = 200) => {
  const [value, setValue] = React.useState<T>(initialValue)

  const debouncedSetValue = useCallback(_.debounce(setValue, delay), [])

  useEffect(() => {
    return () => debouncedSetValue?.cancel?.()
  }, [])

  return [value, debouncedSetValue]
}
